import { React } from "react";
import { ModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import warning from "../../Assets/Icons/warning.png";
import { Button } from "antd";

const ConfirmationModal = ({
  visible,
  icon,
  param,
  confirmAction,
  cancelAction,
  children,
  isOrderSummaryMerge = false,
  isShowCancel=true
}) => {
  return (
    <ModalPopup visible={visible}>
      <div className="Popup-img">
        <img src={icon} alt="Warning" />
      </div>
      <div className="Popup-content">{children}</div>
      <div className="ant-modal-footer-section">
        { isShowCancel &&
        <Button
          key="back"
          className="themeBtn-plane"
          onClick={() => cancelAction()}
        >
          <div className="plusPopUpBorder">
            <Iconmoon
              icon="plus-sign"
              size={9}
              color="#EA655B"
              className="ant-ico-sec"
            />
          </div>
          {isOrderSummaryMerge ? "No" : "Cancel"}
        </Button>
}
        <Button
          key="submit"
          className="themeBtn"
          onClick={() => confirmAction(param)}
        >
          <Iconmoon icon="tick-mark" size={14} color="#ffff" />
          {isOrderSummaryMerge ? "Yes" : "Confirm"}
        </Button>
      </div>
    </ModalPopup>
  );
};

export default ConfirmationModal;
